export default __webpack_public_path__ + "static/Atkinson-Hyperlegible-Italic-102-9d826272a7141f284ab1916b04e3cf1b.ttf";